import { api } from './apiClient'

export const MigrationApi = {
  /**
   * Triggers an async reprocess of all completed uploads for the current tenant to
   * regenerate EAV financial data records. Returns 202 immediately — the job runs on
   * the server; progress and final counts are logged to server logs.
   * Fund-level uploads are processed before investment-level, one at a time.
   */
  reprocessFinancials() {
    return api.post('/api/admin/migration/reprocess-financials')
  },

  /**
   * Triggers an async reprocess of the latest completed upload for a specific
   * investment. Returns 202 immediately — the job runs on the server.
   *
   * @param {string} investmentId
   */
  reprocessInvestment(investmentId) {
    return api.post(`/api/admin/migration/reprocess-investment/${investmentId}`)
  },

  /**
   * Installs EAV manifests (bl_object + fields) for all tenants.
   * Synchronous — resolves only after all manifests are installed.
   * Idempotent, safe to call multiple times.
   */
  bootstrapManifests() {
    return api.post('/api/admin/migration/bootstrap-manifests')
  }
}
